import { z } from 'zod';

const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** "AAAA-MM-DD" que existe no calendário (31/02 e mês 13 não passam). */
export function isValidIsoDay(value: string): boolean {
  const m = ISO_DAY.exec(value);
  if (!m) return false;
  const [year, month, day] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

/** Dia no formato "AAAA-MM-DD", validado de verdade (sem virar outro dia na conversão). */
export const isoDaySchema = z
  .string()
  .regex(ISO_DAY, 'Data inválida.')
  .refine(isValidIsoDay, 'Data inválida.');

/** Dia ("AAAA-MM-DD") de `date` num fuso horário (ex.: o fuso dos jobs agendados). */
export function isoDayIn(timeZone: string, date: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

/** Dia de hoje (ou de `date`) no relógio de quem está usando — não o dia em UTC. */
export function localIsoDay(date: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
